import {
  Activity,
  Percentage,
  Snop,
  Strongbox,
} from "../../../../assets/svg-icons";
export const SNOP = {
  name: "S&OP",
  shortName: "S&OP",
  route: "/snop",
  icon: Snop,
  permissions: ["SNOP_VIEW"],
  routePermissions: ["SNOP_VIEW"],
  extraRoutes: [
    {
      route: "/snop-detail",
      permissions: ["SNOP_VIEW"],
    },
    {
      route: "/snop/create",
      permissions: ["SNOP_CREATE"],
    },
    {
      route: "/snop/setup",
      permissions: ["SNOP_EDIT"],
    },
  ],
};

export const DASHBOARD = {
  name: "Dashboards",
  shortName: "Home",
  icon: Strongbox,
  route: null,
  permissions: [],
  child: {
    "Forecast Accuracy": {
      name: "Forecast Accuracy",
      route: "/snop/fa/dashboard",
      permissions: ["SNOP_DASHBOARD"],
      icon: Activity,
    },
    "Finance Workbench": {
      name: "Finance Workbench",
      route: "/snop/fr/overview",
      icon: Percentage,
      permissions: ["SNOP_FINANCIAL_DASHBOARD"],
    },
  },
};
